import { PlatformApi } from '@/lib/api/platform/platformSdk';
import type { ConnectedApp } from '../model/types';

/** platform-api refuses this endpoint to any OAuth-issued token: first-party session only. */
export const getConnectedApps = async (): Promise<ConnectedApp[]> => {
  const { data } = await PlatformApi.platformApi.get<{ data: ConnectedApp[] }>('/oauth/grants');
  return data.data;
};

export const disconnectApp = async (grantId: string): Promise<void> => {
  await PlatformApi.platformApi.delete(`/oauth/grants/${grantId}`);
};
